module.exports = __webpack_public_path__ + "img/bw.14554f6b.svg";